import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';
import { Sale } from '../types';

export const useSaleById = (id: string) => {
  return useQuery({
    queryKey: ['sale', id],
    queryFn: async (): Promise<Sale | null> => {
      const { data, error } = await supabase
        .from('sales')
        .select('*, sale_photos(photo_url, display_order)')
        .eq('id', id)
        .eq('is_archived', false)
        .single();

      if (error) {
        console.error('Error fetching sale:', error);
        return null;
      }

      return data;
    },
    enabled: !!id,
    staleTime: 1000 * 30, // 30 seconds - consistent with useSales
  });
};
